import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../../interfaces/IReduxState";


export const PreviousClass_CRUDReadSlice = createSlice({
  name: "PreviousClass_CRUDReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    PreviousClass_CRUDRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successPreviousClass_CRUDRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePreviousClass_CRUDRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPreviousClass_CRUDRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  PreviousClass_CRUDRead,
  successPreviousClass_CRUDRead,
  failurePreviousClass_CRUDRead,
  clearPreviousClass_CRUDRead,
} = PreviousClass_CRUDReadSlice.actions;

export default PreviousClass_CRUDReadSlice.reducer;
